import {ReactElement, ReactNode, useState} from 'react';
import classNames from 'classnames';

interface ShopFilterToggleContainerProps {
  title: string;
  children: ReactNode | Array<ReactNode>;
  contentClassName?: string;
  hasReadMoreBlock?: boolean;
}

export default function ShopFilterToggleContainer({
  title,
  children,
  contentClassName,
  hasReadMoreBlock = false,
}: ShopFilterToggleContainerProps): ReactElement {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isShowAllActive, setIsShowAllActive] = useState(false);

  return (
    <div
      role="button"
      tabIndex={-1}
      className={classNames('shop-filter__item', {closed: isCollapsed})}
    >
      <h6
        // eslint-disable-next-line jsx-a11y/aria-role
        role="widget"
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="shop-filter__title shop-filter-title-js"
      >
        {title}
      </h6>

      <div
        className={classNames('shop-filter__contents', contentClassName, {
          'show-all': isShowAllActive,
          'js-read-more-area': hasReadMoreBlock,
        })}
      >
        {children}
        {hasReadMoreBlock && (
          <div
            role="button"
            tabIndex={-1}
            className="qa_read-more js-read-more"
            onClick={() => setIsShowAllActive(!isShowAllActive)}
          >
            <span className="read-less">Show less</span>
            <span className="read-more">Show more</span>
          </div>
        )}
      </div>
    </div>
  );
}
